














import {Component, Vue} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import {Photo} from '@/store/types'

@Component({})
export default class TaskPhotosList extends Vue {
  @Getter('photos') public photos!: Photo[]
  @Action('deletePhoto') public deletePhoto!: any

  public openPhoto(photo: Photo) {
    window.open(photo.url, '_blank')
  }

  public removePhoto(photo: Photo) {
    this.deletePhoto({id: photo.id})
  }

  public nameFormat(photo: Photo) {
    return 'Image-' + (photo.id) + '.png'
  }

}
